"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var history_1 = __importDefault(require("./history"));
var Login_1 = __importDefault(require("../components/Login/View/Login"));
var routes_1 = require("../router/routes");
var userContext_1 = require("../context/UserContext/userContext");
var user_hook_1 = require("../context/UserContext/user.hook");
var ClientRouter_1 = __importDefault(require("../router/ClientRouter"));
var roles_1 = require("../router/roles");
var AdminRouter_1 = __importDefault(require("../router/AdminRouter"));
var SuperAdminRouter_1 = __importDefault(require("../router/SuperAdminRouter"));
var AuditorRouter_1 = __importDefault(require("../router/AuditorRouter"));
var UmvaRouter = function () {
    var userCntx = (0, user_hook_1.useUser)();
    return (react_1.default.createElement(userContext_1.UserContext.Provider, { value: userCntx },
        react_1.default.createElement(react_router_dom_1.Router, { history: history_1.default },
            react_1.default.createElement(react_router_dom_1.Switch, null,
                react_1.default.createElement(react_router_dom_1.Route, { component: Login_1.default, exact: true, path: routes_1.NonAuthRoutes.login }),
                userCntx.user &&
                    userCntx.user.roles &&
                    roles_1.roles.superAdmins.includes(userCntx.user.roles[0].name) && (react_1.default.createElement(SuperAdminRouter_1.default, null)),
                userCntx.user &&
                    userCntx.user.roles &&
                    roles_1.roles.admins.includes(userCntx.user.roles[0].name) && (react_1.default.createElement(AdminRouter_1.default, null)),
                userCntx.user &&
                    userCntx.user.roles &&
                    roles_1.roles.auditors.includes(userCntx.user.roles[0].name) && (react_1.default.createElement(AuditorRouter_1.default, null)),
                userCntx.user &&
                    userCntx.user.roles &&
                    roles_1.roles.users.includes(userCntx.user.roles[0].name) && (react_1.default.createElement(ClientRouter_1.default, { user: userCntx.user }))))));
};
exports.default = UmvaRouter;
